import React, { useState } from 'react';
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const CustomDateRangePicker = ({ onDateChange }) => {
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });

    const onRangeDateChange = (dates) => {
        if (dates) {
            const formattedFrom = dates[0].format('YYYY-MM-DD'); //format for date from
            const formattedTo = dates[1].format('YYYY-MM-DD'); //format for date until
            
            setSelectedDayRange({
                from: formattedFrom,
                to: formattedTo,
            });

            onDateChange({
                from: formattedFrom,
                to: formattedTo,
            }); //NOTIFY THE CHANGE TO THE FATHER
        } else {
            setSelectedDayRange({
                from: null,
                to: null,
            });
            onDateChange({
                from: null,
                to: null,
            }); //NOTIFY THE CHANGE TO THE FATHER
        }
    };

    const rangePresets = [
        {
            label: 'Last 7 Days',
            value: [dayjs().add(-7, 'd'), dayjs()],
        },
        {
            label: 'Last 14 Days',
            value: [dayjs().add(-14, 'd'), dayjs()],
        },
        {
            label: 'Last 30 Days',
            value: [dayjs().add(-30, 'd'), dayjs()],
        },
        {
            label: 'Last 90 Days',
            value: [dayjs().add(-90, 'd'), dayjs()],
        },
    ];

    return (
        <Space direction="vertical" size={12}>
            <RangePicker
                presets={rangePresets}
                onChange={onRangeDateChange}
                size="large"
            />
        </Space>
    );
};

export default CustomDateRangePicker;
